import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "components/NoDataFound";
import { handleError } from "utils";
import { showSuccess } from "services/toast.service";
import RemoveButton from "components/Button/RemoveButton";
import Loader from "components/Loader";
import UpdateButton from "components/Button/UpdateButton";
import { API_BASE_URL } from "config/constants";
import { getAccessToken } from "utils";
import { getUser } from "utils";
import { getCoverage } from "utils";
import { ROLES } from "config/roles";

export default function Analytics({ color }) {
  const data = [];
  const history = useHistory();
  const [analytics, setAnalytics] = useState(data);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedAnalytictId, setSelectedAnalyticId] = useState(0);
  const [gettingData, setGettingData] = useState(false);
  const [keyword, setKeyword] = useState("");
  const user = getUser();

  const get = async () => {
    try {
      setGettingData(true);

      const responce = await axios.get(`${API_BASE_URL}/analytic?page=1`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
      });

      setGettingData(false);
      const apiData = responce.data;
      setAnalytics(apiData.result.data.result);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  useEffect(() => {
    get();
  }, []);

  //Delete
  const DeleteAnalytic = async (id) => {
    try {
      setSelectedAnalyticId(id);
      setDeleteLoading(true);
      const deleteResponse = await axios.delete(`${API_BASE_URL}/analytic`, {
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
        data: {
          id: id,
        },
      });

      setSelectedAnalyticId(0);
      setDeleteLoading(false);
      showSuccess(deleteResponse?.data?.result?.message);
      get();
    } catch (error) {
      setSelectedAnalyticId(0);
      setDeleteLoading(false);
      handleError(error);
    }
  };

  const goToUpdateData = (data) => {
    history.push("/admin/update-analytic", {
      data,
    });
  };

  const filterData = (data) => {
    if (!keyword) return true;
    if (data.inventoryName.toLowerCase().includes(keyword.toLowerCase())) {
      return true;
    }
    return false;
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative flex justify-items-start gap-2 items-center w-full px-4 max-w-full flex-grow flex-1">
              {" "}
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                All Analytics
              </h3>
              <Loader loading={gettingData} />
            </div>
            {
              (![ROLES.Advertizer, ROLES.Publisher].includes(user.role)) && (
                <Link to="/admin/add-analytic">
                  <button
                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                  >
                    Add New Analytics
                  </button>
                </Link>
              )
            }
          </div>
        </div>

        <div className="flex px-4 pb-3">
          <input
            type="text"
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full lg:w-1/3 ease-linear transition-all duration-150"
            placeholder="Search.."
            name="clicks"
            value={keyword}
            onChange={handleKeywordChange}
          />
        </div>

        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Website Name
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Date
                </th>



                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Ad Request
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Matched Request
                </th>









                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Coverage
                </th>



                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Clicks
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  CTR
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Revenue
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Ad impression
                </th>

             

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  CPM
                </th>

             

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Created On
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Updated On
                </th>

                {/* <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Status
                </th> */}

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {analytics[0] ? (
                <>
                  {analytics.filter(filterData).map((anly) => {
                    return (
                      <tr>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {anly.inventoryName}
                        </td>
                        <td className="border-t-0 px-6 alig n-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {moment(anly.date).format("ll")}
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {anly.adRequests}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{anly.matchedRequests}</span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {getCoverage(anly.matchedRequests, anly.adRequests)}
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{anly.clicks}</span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{anly.ctr.toFixed(2)}%</span>
                          </div>
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">${anly.grossRevenue}</span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{anly.impressions}</span>
                          </div>
                        </td>
                       
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">${anly.cpm}</span>
                          </div>
                        </td>

                    

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(anly.createdAt).format("llll")}
                            </span>
                          </div>
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(anly.updatedAt).format("llll")}
                            </span>
                          </div>
                        </td>
                        {/* 
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {anly.isActive ? (
                                <>
                                  <i className="fas fa-circle text-green-500 mr-2"></i>{" "}
                                </>
                              ) : (
                                <>
                                  {" "}
                                  <i className="fas fa-circle text-yellow-500 mr-2"></i>{" "}
                                </>
                              )}
                            </span>
                          </div>
                        </td> */}

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <UpdateButton
                              onClick={() => goToUpdateData(anly)}
                            />

                            {user.role === "Admin" && (
                              <RemoveButton
                                onClick={() => DeleteAnalytic(anly._id)}
                                loading={
                                  deleteLoading &&
                                  selectedAnalytictId === anly._id
                                }
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <td colSpan={13}>
                  <NoDataFound />
                </td>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
